module.exports = __webpack_public_path__ + "img/index1.f83ed2ed.jpg";